import { styled } from '@mui/material/styles'
import { Switch } from '@mui/material'

const Switch_GrmDark = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-thumb': {
    backgroundColor: '#a44c0e',
  },
  '& .Mui-disabled' : {
    '& .MuiSwitch-thumb': {
      backgroundColor: '#b9ad9c'
    }
  }
}))

export default Switch_GrmDark